<template>
	<li :class="`shop-item salespoint-${item.id}`">
		<router-link :to="{ name: 'single-salespoint', params: { uuid: item.id} }" class="thumbnail-container">
			<img src="@/assets/imgs/kc-logo.png" :alt="`${item.title} - Thumbnail`">
		</router-link>
		<div class="content-container">
			<div class="type-container" v-if="item.type">
				<div class="type category-shop" v-for="type in entityTypes" :key="`type-${type}`">{{ type }}</div>
			</div>
			<h3 class="shop-title">
				<router-link :to="{ name: 'single-salespoint', params: { uuid: item.id} }">
					{{ itemTitle }}
				</router-link>
			</h3>
			<div class="meta-infos">
				<span class="distance" v-if="item.distance">
					<font-awesome-icon :icon="['far', 'location-arrow']" />
					{{ (item.distance/1000).toFixed(0) + ' km' }}
				</span>
				<span class="likes" v-if="item.likes">
					<font-awesome-icon :icon="['far', 'thumbs-up']" />
					{{ item.likes }}
				</span>
			</div>
		</div>
		<div class="actions-container">
			<button type="button" :class="{ 'button hollow btn-add-to-bookmarks' :true, 'in-bookmarks': inBookmarks}" @click="toggleBookmark">
				<font-awesome-icon :icon="bookmarkIcon"	/>
			</button>
		</div>
	</li>
</template>

<script>
	export default {
		name: 'ShopItem',
		props: {
			item: {
				type: Object,
				default () {
					return null
				}
			},
			entity: {
				type: String,
				default: ''
			}
		},
		computed: {
			itemTitle(){
				return this.item.title.replace('&amp;', '&')
			},
			inBookmarks () {
				return this.$store.getters.getCurrentBookmarks.filter(company => company.id === this.item.id).length === 1
			},
			bookmarkIcon () {
				if (this.inBookmarks) {
					return ['fas', 'heart']
				} else {
					return ['fal', 'heart']
				}
			},
			entityTypes () {
				let types = Object.values(this.item.type)
				let displayTypes = []

				switch(this.entity) {
					case 'week-cards':
						displayTypes = types.filter(type => {
							// return types to display
							return type === 'Verkaufsstelle'
						})
						return displayTypes
					case 'season-cards':
						displayTypes = types.filter(type => {
							// return types to display
							return type != 'Verkaufsstelle'
						})

						return displayTypes
				}

				return displayTypes
			}
		},
		methods: {
			toggleBookmark (){
				if (this.inBookmarks) {
					this.removeFromBookmarks()
				} else {
					this.addToBookmarks()
				}
			},
			removeFromBookmarks () {
				this.$store.dispatch('removeBookmark', this.item.id)
			},
			addToBookmarks () {
				let bookmarkObject = {
					id: this.item.id,
					type: 'salespoint'
				}
				this.$store.dispatch('createBookmark', bookmarkObject)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.shop-item{
		@include xy-grid();
		padding: 1rem;
		border-top: 1px solid $light-gray;
		border-bottom: 1px solid $light-gray;
		margin-bottom: .5rem;
		background-color: $white;
		box-shadow: 0px 0px 2px rgba($black, .15);

		.thumbnail-container{
			@include xy-cell(5, false, 0);
			display: flex;
			justify-content: center;
			align-items: center;
			min-height: 100px;
			border-radius: rem-calc(3);

			img {
				border-radius: rem-calc(3);
			}
		}

		.content-container{
			@include xy-cell(6, false, 0);
			display: flex;
			flex-direction: column;
			padding-left: 1rem;

			.type-container{
				.type{
					font-size: rem-calc(12);
					text-transform: uppercase;
				}
			}
			.shop-title{
				margin-bottom: 1rem;
				color: get-color(primary);
				font-weight: 700;
				line-height: 1.2;
				word-break: break-word;
			}
			.meta-infos{
				margin-top: auto;
				color: $medium-gray;
				.distance{
					margin-right: 1rem;
				}
				.likes{
				}
			}
		}

		.actions-container{
			@include xy-cell(1, false, 0);
			@include flex();
			@include flex-align(right, top);

			.btn-add-to-bookmarks{
				display: flex;
				justify-content: center;
				align-items: center;
				width: 2rem;
				height: 2rem;
				margin: 0;
				padding: .25rem;
				border-radius: 20rem;

				svg {
					margin-top: 2px;
				}

				&.in-bookmarks {
					background-color: rgba(get-color(primary), .2);
				}
			}
		}


		@include breakpoint(medium) {
			.content-container {
				.shop-title {
					font-size: 1rem;
					margin-top: 1rem;
				}
			}
			.thumbnail-container {
				@include xy-cell(4.4, false, 0);
			}

			.actions-container {
				@include xy-cell(1.6, false, 0 );
			}
		}

		@include breakpoint(large only) {
			.content-container {
				.shop-title {
					font-size: 1rem;
					margin-top: 1rem;
				}
			}
		}

		@include breakpoint(xlarge only) {
			.content-container {
				.shop-title {
					font-size: 1.2rem;
					margin-top: 1rem;
				}
			}
		}
	}
</style>
